import styled from "styled-components";

// import colors from '../../constants/colors'
import breakpoints from "../../constants/breakpoints";
// import fonts from '../../constants/fonts'

export const RegistrationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  scroll-behavior: smooth;
  & .react-tabs__tab-panel--selected {
    display: block;
  }
  & > span {
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 100;
    cursor: pointer;
    @media screen and (max-width: ${breakpoints.desktopXL.pixels}) {
      & > svg {
        transform: scale(0.6);
      }
    }
    @media screen and (max-width: ${breakpoints.ipad.pixels}) {
      bottom: 8px;
      right: 8px;
      & > svg {
        transform: scale(0.4);
      }
    }
  }
`;
